import type {BaseUrlsStrategyData} from './types/base-urls-data.type';

export abstract class BaseUrlsStrategyService {
  abstract getBaseUrls(): BaseUrlsStrategyData;
}
